import * as React from "react";
import * as locales from "../../../../locales.json";
import { I18n } from "i18n-js";
const i18n = new I18n(locales);
i18n.defaultLocale = "en";
i18n.locale = (window as any).locale || "";

import CreditCardPaymentMethod from "./creditCardPaymentMethod";
import InvoicePaymentMethod from "./invoicePaymentMethod";
import { BillingType, PaymentMethodPropTypes } from "../lib/types";

const PaymentMethod = ({
  cardType,
  expiration,
  last4,
  fetchData,
  openPortal,
  paymentDueOn,
  paymentMethodOnFile,
  refillAmount,
  refillThreshold,
  rewardBillingType,
  setPageLoading,
  setRefetchData,
  subscriptionAutoCollection,
  subscriptionId,
  type,
  updateToastMessage,
}: PaymentMethodPropTypes): React.ReactElement => {
  if (type === "reward") {
    return (
      <>
        {rewardBillingType === BillingType.Fixed ? (
          <InvoicePaymentMethod
            cardType={cardType}
            last4={last4}
            fetchData={fetchData}
            openPortal={openPortal}
            paymentDueOn={paymentDueOn}
            paymentMethodOnFile={paymentMethodOnFile}
            refillAmount={refillAmount}
            refillThreshold={refillThreshold}
            setPageLoading={setPageLoading}
            subscriptionId={subscriptionId}
            type={type}
            updateToastMessage={updateToastMessage}
          />
        ) : (
          <CreditCardPaymentMethod
            cardType={cardType}
            last4={last4}
            expiration={expiration}
            openPortal={openPortal}
            rewardBillingType={rewardBillingType}
            setRefetchData={setRefetchData}
            subscriptionAutoCollection={subscriptionAutoCollection}
          />
        )}
      </>
    );
  }

  if (type === "subscription") {
    return (
      <>
        {subscriptionAutoCollection === "on" ? (
          <CreditCardPaymentMethod
            cardType={cardType}
            last4={last4}
            expiration={expiration}
            openPortal={openPortal}
            rewardBillingType={rewardBillingType}
            setRefetchData={setRefetchData}
            subscriptionAutoCollection={subscriptionAutoCollection}
          />
        ) : (
          <InvoicePaymentMethod
            cardType={cardType}
            last4={last4}
            fetchData={fetchData}
            openPortal={openPortal}
            paymentDueOn={paymentDueOn}
            paymentMethodOnFile={paymentMethodOnFile}
            refillAmount={refillAmount}
            refillThreshold={refillThreshold}
            setPageLoading={setPageLoading}
            subscriptionId={subscriptionId}
            type={type}
            updateToastMessage={updateToastMessage}
          />
        )}
      </>
    );
  }
};

export default PaymentMethod;
